import { createFileRoute } from '@tanstack/react-router'
import { ComplianceReportsPage } from '@/features/ndis-standards/reports'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute('/_authenticated/_organization/ndis-standards/reports')({
  beforeLoad: async () => requireActiveSubscription(),
  component: ComplianceReportsPage,
})
